<div class="main-container">

    <p>{{ ineligibilityReason }}</p>

    <p>Please click <a [href]="shopReturnUrl">here</a> to return to the shop and select an alternate subscription.</p>

</div>

